module.exports = __webpack_public_path__ + "assets/img/sbac_header_top_banner.webp?2afcf1c705b504b698189c244b75ef8c";